export default "__VITE_ASSET__Dj_NaOlX__"